import React, {Component} from 'react';

import MediaQuery from 'react-responsive';

import config from '../../../config';

class Responsive extends Component {

  static matches = {
    desktop: 'desktop',
    tablet: 'tablet',
    tabletDown: 'tablet-down',
    mobileUp: 'mobile-up',
    mobile: 'mobile'
  };

  match(match) {

    const {children, component = false, ...rest} = this.props;

    let matchFunction = children;

    if (component) {
      matchFunction = (match) => match ? component : null;
    } else if (typeof children !== "function") {
      matchFunction = (match) => match ? children : null;
    }

    switch (match) {
      case Responsive.matches.desktop :
        return <MediaQuery {...rest} children={matchFunction} minWidth={config.tabletBreakpoint + 1}/>;
      case Responsive.matches.tablet :
        return <MediaQuery {...rest} children={matchFunction} minWidth={config.mobileBreakpoint + 1}
                           maxWidth={config.tabletBreakpoint}/>;
      case Responsive.matches.tabletDown :
        return <MediaQuery {...rest} children={matchFunction} maxWidth={config.tabletBreakpoint}/>;
      case Responsive.matches.mobileUp :
        return <MediaQuery {...rest} children={matchFunction} minWidth={config.mobileBreakpoint + 1}/>;
      case Responsive.matches.mobile :
        return <MediaQuery {...rest} children={matchFunction} maxWidth={config.mobileBreakpoint}/>;
      default:
        return null
    }

  }

  render() {
    return (
      <React.Fragment>
        {this.match(this.props.match)}
      </React.Fragment>
    );
  }

}


export default Responsive;

